<template>
  <div class="TrainingCallToAction">
    <list-call-to-action-bullet
      class="TrainingCallToAction-Bullet"
      icon="chart_line"
      title="Cursos de Aperfeiçoamento"
      description="Atualize conhecimentos e habilidades técnicas e comportamentais."
    />

    <list-call-to-action-bullet
      class="TrainingCallToAction-Bullet"
      icon="graduation"
      side="right"
      title="Workshop e Formação Continuada"
      description="Aprimore o desempenho profissional."
    />

    <list-call-to-action-bullet
      class="TrainingCallToAction-Bullet"
      icon="microphone"
      title="Palestras"
      description="Informe-se e estimule-se com conceitos e ideias de áreas específicas."
    />

    <div class="TrainingCallToAction-ButtonWrapper">
      <rounded-button
        class="TrainingCallToAction-Button"
        @click="click()"
      >
        Saiba mais
      </rounded-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import "~@/styles/_variables.scss";

  .TrainingCallToAction {
    width: 100%;

    &-Title {
      margin-bottom: 20px;
    }

    &-Bullet {
      width: 100%;
    }

    &-ButtonWrapper {
      margin: 50px 0;
      width: 100%;
      text-align: center;
    }

    &-Button {
      max-width: 200px;
      display: inline-block;
    }
  }
</style>

<script>
  import TheButton from "@/components/TheButton";
  import TheIcon from "@/components/TheIcon";
  import RoundedButton from './RoundedButton.vue';
  import ListCallToActionBullet from './ListCallToActionBullet.vue';

  export default {
    name: "TrainingCallToAction",

    components: {
      TheIcon,
      TheButton,
      RoundedButton,
        ListCallToActionBullet,
    },

    methods: {
      click() {
        this.$emit("click");
      },
    },
  };
</script>
